import modalDietHistory from './components/guestActivity/modalDietHistory';
import modalTeam from './components/pais/modalTeam';
import infusionForm from './components/infusionTherapy/infusionForm';
import warningMsg from './components/warningMsg';
import collapseAlert from './components/welcomeAlert/collapseAlert';
import error from './components/error';
import gdpractivator from './components/gdpr/gdpractivator';
import guestDrugsRecog from './components/guestDrugsRecog/guestDrugsRecog';
import guestEvents from './components/guestEvents/guestEvents';
import guestMeasurements from './components/guestMeasurements/guestMeasurements';
import modalActivityReport from './components/report/modalActivityReport';
import paiTargets from './components/pais/paiTargets';
import newPaiTargets from './components/pais/newPaiTargets';
import listPermissions from './components/permissions/listPermissions';
import paisVerifications from './components/pais/paisVerifications';
import drugSwap from './components/drugSwap/drugSwap';
import consents from './components/consents/consents';
import documents from './components/documents/documents';
import paisTeams from './components/pais/paisTeams';
import phoneVerification from './components/authentication/phoneVerification';
import reachedLinkChange from './components/pais/reachedLinkChange';
import vSelect2 from './components/vSelect2';
import vSelect2Wrapper from './components/vSelect2Wrapper';
import richTextEditor from './components/richTextEditor';
import rsaaEndPai from './components/domestics/rsaaEndPai';
import briefcases from './components/domestics/briefcases';
import briefcasesDiscarge from './components/domestics/briefcasesDiscarge';
import massiveRegistrations from './components/domestics/massiveRegistrations';
import changeUserEmailModal from './components/users/changeUserEmailModal';
import importAbsences from './components/absencesCalendar/importAbsences';
import reportTemplates from './components/print/reportTemplates';
import spinner from './components/spinner';
import subActivitiesConfig from './components/activity/subActivitiesConfig';
import fluxExportsIndex from './components/flux_exports/fluxExportsIndex';
import userMedia from './components/userMedia';
import drugsSomministrations from './components/somministration/drugsSomministrations';
import drugsPreparations from './components/preparation/drugsPreparations';
import priceConditions from './components/priceConditions';
import daysOfMonth from './components/daysOfMonth';
import activitiesBriefcase from './components/activity/activitiesBriefcase';
import guestDrugsInteraction from './components/guestDrugs/guestDrugsInteraction';
import reportTemplatesRequirements from './components/print/reportTemplatesRequirements';
import optionsSection from './components/print/filters/optionsSection';
import datepicker from './components/datepicker';
import guestProtections from './components/guestProtections/guestProtections';
import commercialDrugsModal from './components/guestDrugs/commercialDrugsModal';
import dataExtractionMenu from './components/menu_reports/dataExtractionMenu';
import tableActivityDomestic from './components/domestics/tableActivityDomestic';
import genericFiltersModal from './components/genericFiltersModal';
import openProfilesView from './components/siad/openProfilesView';
import cp2ValDomesticsPrices from './components/cp/cp2ValDomesticsPrices';
import confirmedTherapies from './components/confirmedTherapies/confirmedTherapies';
import whitelistActivitiesContainer from './components/guestPeriodDataSet/whitelistActivitiesContainer';
import exceededUsersLimitCount from './components/users/exceededUsersLimitCount';
import guestExams from './components/guestExams/guestExams';
import guestActivityPlanForm from './components/guestActivityPlan/guestActivityPlanForm';
import deadlineForm from './components/deadlines/deadlineForm';
import guestPeriodDataSetExtensions from './components/guestPeriodDataSetExtensions/guestPeriodDataSetExtensions';
import DataSetExtensionFormModal from './components/guestPeriodDataSetExtensions/DataSetExtensionFormModal';
import guestSearchOnMpi from './components/guest/guestSearchOnMpi';
import adtSearch from './components/adt/adtSearch';
import siadImportsIndex from './components/siad_imports/siadImportsIndex';
import siadConvertersIndex from './components/siad_converters/siadConvertersIndex';
import fe1FluxTxtComponent from './components/fe1/fe1FluxTxtComponent';
import fe4FluxTxtComponent from './components/fe4/fe4FluxTxtComponent';
import stepper from './components/stepper';
import preview from './components/preview/preview';
import modalReportFirme from './components/report/modalReportFirme';
import paisTargetsVerifications from './components/pais/paisTargetsVerifications';
import VCalendar from 'v-calendar';
import ToggleButton from 'vue-js-toggle-button';

export const staticComponents = {
  briefcases,
  briefcasesDiscarge,
  infusionForm,
  VCalendar,
  collapseAlert,
  error,
  optionsSection,
  guestDrugsRecog,
  guestEvents,
  guestMeasurements,
  gdpractivator,
  modalActivityReport,
  modalDietHistory,
  changeUserEmailModal,
  importAbsences,
  drugsSomministrations,
  drugsPreparations,
  warningMsg,
  paiTargets,
  documents,
  drugSwap,
  consents,
  paisTeams,
  paisVerifications,
  phoneVerification,
  massiveRegistrations,
  newPaiTargets,
  listPermissions,
  reachedLinkChange,
  vSelect2,
  vSelect2Wrapper,
  modalTeam,
  reportTemplatesRequirements,
  richTextEditor,
  reportTemplates,
  rsaaEndPai,
  spinner,
  subActivitiesConfig,
  fluxExportsIndex,
  daysOfMonth,
  userMedia,
  priceConditions,
  activitiesBriefcase,
  guestDrugsInteraction,
  datepicker,
  guestProtections,
  commercialDrugsModal,
  tableActivityDomestic,
  dataExtractionMenu,
  genericFiltersModal,
  openProfilesView,
  cp2ValDomesticsPrices,
  confirmedTherapies,
  ToggleButton,
  whitelistActivitiesContainer,
  exceededUsersLimitCount,
  guestActivityPlanForm,
  deadlineForm,
  guestPeriodDataSetExtensions,
  DataSetExtensionFormModal,
  guestSearchOnMpi,
  adtSearch,
  guestExams,
  siadImportsIndex,
  siadConvertersIndex,
  fe1FluxTxtComponent,
  fe4FluxTxtComponent,
  stepper,
  preview,
  modalReportFirme,
  paisTargetsVerifications,
};
